<template>
  <div class="information-bar">
    <second-menu-link-content>
      <template v-slot:header>
        <span>底部信息</span>
      </template>
      <template v-slot:content>
        <div class="information-bar-main">
          <div class="add-classify">
            <el-button class="btn-blue" @click="openVisible">新增大类</el-button>
            <span class="note">底部信息最多可设置5个大类，每个类目可设置5个子类</span>
            <el-dialog title="新增模块" :visible.sync="dialogVisible" width="400px" top="25vh">
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="板块名称：" prop="title">
                  <el-input v-model="ruleForm.title" class="gray" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="btn-white" type="primary" @click="reset('ruleForm')">取消</el-button>
                  <el-button class="btn-blue" @click="add('ruleForm')">保存</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </div>
          <div class="contanier">
            <div class="lists" v-for="(value,index) in datas" :key="index">
              <div class="title">
                <span>{{ value.name }}</span>
                <div class="title-right">
                  <el-button class="btn-text" type="text" @click="addChild(value)">新增子类</el-button>
                  <el-button class="btn-text" type="text" @click="modify(value)">修改</el-button>
                  <el-button class="btn-text" type="text" @click="deleteClass(value.id)">删除</el-button>
                </div>
              </div>
              <ul class="child-lists">
                <li class="child-lists-li" v-for="(v,i) in value.bottomModuleInfos" :key="i">
                  <span>{{ v.title }}</span>
                  <div class="right">
                    <el-button class="btn-text" type="text" @click="goEditDetail(v.id)">编辑</el-button>
                    <el-button class="btn-text" type="text" @click="remove(v.id)">删除</el-button>
                  </div>
                </li>
              </ul>
            </div>
            <el-dialog title="新增子类" :visible.sync="dialogVisible2" width="400px" top="25vh">
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="ruleForm"
              >
                <el-form-item label="板块名称：" prop="title">
                  <el-input v-model="ruleForm.title" class="gray" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="btn-white" type="primary" @click="reset('ruleForm')">取消</el-button>
                  <el-button class="btn-blue" @click="addChildName('ruleForm')">保存</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
            <el-dialog title="修改名称" :visible.sync="dialogVisible3" width="400px" top="25vh">
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="ruleForm"
              >
                <el-form-item label="板块名称：" prop="title">
                  <el-input v-model="ruleForm.title" class="gray" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="btn-white" type="primary" @click="reset('ruleForm')">取消</el-button>
                  <el-button class="btn-blue" @click="saveModify('ruleForm')">保存</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBMall from 'models/db/mall.js';
const dbMall = new DBMall();
export default {
  data() {
    return {
      ruleForm: {
        title: '',
        id: ''
      },
      rules: {
        title: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      },
      datas: [
        // {
        //   name: '购物指南',
        //   bottomModuleInfos: [
        //     {
        //       title: '哈哈哈哈'
        //     },
        //     {
        //       title: '哈哈哈哈'
        //     },
        //     {
        //       title: '哈哈哈哈'
        //     }
        //   ]
        // }
      ],
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false
    };
  },
  components: {
    SecondMenuLinkContent
  },
  beforeMount() {
    this.getBottom();
  },
  methods: {
    // 获取底部数据
    getBottom() {
      dbMall.postDBBottom().then(res => {
        if (res.success) {
          this.datas = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 一级分类弹框
    openVisible() {
      this.dialogVisible = true;
      this.ruleForm.title = '';
      this.ruleForm.id = '';
    },
    // 取消
    reset(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.dialogVisible2 = false;
      this.dialogVisible2 = false;
      this.dialogVisible3 = false;
    },
    // 新增大类
    add(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.datas.length < 5) {
            let name = this.ruleForm.title;
            dbMall.postDBAddBottom(name).then(res => {
              if (res.success) {
                this.$refs[formName].resetFields();
                this.dialogVisible = false;
                this.getBottom();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            this.$message.error('最多设置5个大类！');
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 新增子类弹框
    addChild(value) {
      if (value.bottomModuleInfos.length < 5) {
        this.dialogVisible2 = true;
        this.ruleForm.title = '';
        this.ruleForm.id = value.id;
      } else {
        this.$message.error('最多设置5个大类！');
      }
    },
    // 点击保存新增子类按钮
    addChildName(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let title = this.ruleForm.title;
          let moduleId = this.ruleForm.id;
          dbMall.postDBBottomInfo(moduleId, title).then(res => {
            if (res.success) {
              this.$refs[formName].resetFields();
              this.dialogVisible2 = false;
              this.getBottom();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 修改名称弹框
    modify(value) {
      this.dialogVisible3 = true;
      this.ruleForm.title = value.name;
      this.ruleForm.id = value.id;
    },
    // 确认修改
    saveModify(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let name = this.ruleForm.title;
          let id = this.ruleForm.id;
          dbMall.postDBUpdateBottom(id, name).then(res => {
            if (res.success) {
              this.$refs[formName].resetFields();
              this.dialogVisible3 = false;
              this.getBottom();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 删除大类
    deleteClass(id) {
      this.$confirm(`是否确认删除该大类`, '删除大类', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        dbMall.postDBDeleteBottom(id).then(res => {
          if (res.success) {
            this.getBottom();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 删除子类
    remove(id) {
      this.$confirm(`是否确认删除该子类`, '删除子类', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        dbMall.postDBDeleteBottomInfo(id).then(res => {
          if (res.success) {
            this.getBottom();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 编辑
    goEditDetail(id) {
      this.$router.push({ path: 'edit-detail', query: { id: id } });
    }
  }
};
</script>

<style lang="scss" scoped>
.information-bar {
  width: 100%;
  height: 100%;
  .information-bar-main {
    .add-classify {
      display: flex;
      align-items: flex-end;
      margin-bottom: 16px;
      .el-button {
        width: 128px;
        margin-right: 8px;
        letter-spacing: 2px;
      }
      .note {
        font-size: 12px;
        font-weight: 400;
        color: rgba(144, 147, 153, 1);
        line-height: 20px;
      }
    }
    .contanier {
      .lists {
        margin-bottom: 16px;
        border: 1px solid #f2f6fc;
        border-radius: 8px 8px 0px 0px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(96, 98, 102, 1);
        border-bottom: 0;
        .title {
          height: 32px;
          border-radius: 8px 8px 0px 0px;
          background: rgba(245, 247, 250, 1);
          padding: 0 24px 0 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .title-right {
            .el-button {
              margin-left: 8px;
            }
          }
        }
        .child-lists {
          .child-lists-li {
            height: 32px;
            padding: 0 24px 0 24px;
            border-bottom: 1px solid #f2f6fc;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.information-bar {
  .information-bar-main {
    .el-dialog {
      border-radius: 4px;
      .el-dialog__header {
        padding: 0 24px;
        line-height: 48px;
        color: #606266;
        font-family: "PingFangSC-Medium";
        letter-spacing: 1px;
        .el-dialog__title {
          font-size: 16px;
          color: #606266;
          font-weight: 500;
        }
        .el-dialog__headerbtn {
          top: 15px;
        }
      }
      .el-dialog__body {
        padding: 0px 16px 16px 16px;
        .border {
          border-bottom: 1px solid #f7f7f7;
          margin-bottom: 16px;
        }
        .el-form {
          .el-form-item:last-child {
            margin-bottom: 0px;
          }
          .el-form-item {
            margin-bottom: 16px;
            .el-form-item__label {
              line-height: 32px;
            }
            .el-form-item__content {
              line-height: 32px;
              .el-select {
                width: 100%;
              }
              .el-form-item__error {
                padding-top: 2px;
              }
              .el-button {
                width: 96px;
                letter-spacing: 4px;
              }
              .el-button.btn-blue {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
